import { PillProps } from '../types/PillProps';
import { Close } from './icons/Close';

/** Primary UI component for user interaction */
export const Pill = ({
  className,
  colour,
  children,
  label,
  onClick
}: PillProps) => {
  switch (colour) {
    case 'golden':
      colour =
        'border-golden-light hover:border-golden-dark focus:border-none focus: focus:shadow-circle-golden active:border-none active: active:shadow-circle-golden';
      break;
    case 'cyan':
      colour =
        ' border-cyan-light hover:border-cyan-dark focus:border-none focus: focus:shadow-circle-cyan active:border-none active: active:shadow-circle-cyan';
      break;
    case 'magenta':
      colour =
        ' border-magenta-light hover:border-magenta-dark focus:border-none focus: focus:shadow-circle-magenta active:border-none active: active:shadow-circle-magenta';
      break;
    case 'teal':
      colour =
        ' text-white border-teal-light hover:border-teal-dark focus:border-none focus: focus:shadow-circle-teal active:border-none active: active:shadow-circle-teal';
      break;
    case 'bluestone':
      colour =
        ' text-white border-bluestone-light hover:border-bluestone-dark focus:border-none focus: focus:shadow-circle-bluestone active:border-none active: active:shadow-circle-bluestone';
      break;
    case 'white':
    default:
      colour =
        'text-bluestone border-golden-light hover:border-golden-dark focus:border-none focus: focus:shadow-circle-golden active:border-none active: active:shadow-circle-golden';
      break;
  }


  return (
    <div
      className={
        `flex py-2 px-3 items-center gap-2 rounded-full border w-fit text-center text-xs font-bold cursor-pointer ` +
        colour +
        ' ' +
        className
      }
      onClick={onClick}>
      <span>
        {label}
        {children}
      </span>
      <span>
        <Close variant='dark' className={`w-3 h-auto`} />
      </span>
    </div>
  );
};
